import i18n from 'services/i18n'

export function convertMinutesToHours (time) {
    if (time === 0) {
        return time + i18n.t('General.minutesAbbreviation')
    }

    let hours = Math.floor(time / 60)
    let minutes = time % 60
    hours = hours !== 0 ? hours + i18n.t('General.hoursAbbreviation') + ' ' : ''
    minutes = minutes !== 0 ? minutes + i18n.t('General.minutesAbbreviation') : ''

    return  hours + minutes
}

export function convertMinutesToHoursRawNumber (time) {
    const hours = (time / 60).toFixed(2)
    return +hours
}

export function convertMinutesToDays (time, dayInHours= 24) {
    let dayInMinutes = 60 * dayInHours
    let days = Math.floor(time / dayInMinutes)
    let remainingTime = time - Math.floor(days * dayInMinutes)
    let hours = Math.floor(remainingTime / 60)
    let minutes = time % 60

    days = days !== 0 ? days + i18n.t('General.daysAbbreviation') + ' ' : ''
    hours = hours !== 0 ? hours + i18n.t('General.hoursAbbreviation') + ' ' : ''
    minutes = minutes !== 0 ? minutes + i18n.t('General.minutesAbbreviation') : ''

    return days + hours + minutes
}

export default {
    methods: {
        convertMinutesToHours: convertMinutesToHours,
        convertMinutesToHoursRawNumber: convertMinutesToHoursRawNumber,
        convertMinutesToDays: convertMinutesToDays
    }
}

